import React, { useEffect, useState } from 'react'

import { isMobile } from 'react-device-detect'
import { useLocation, useNavigate } from 'react-router-dom'
import useGetMePlan from 'hooks/query/useGetMePlan'

import { UsageRequestFactor } from 'service/list'
import useGetUsageRequest from 'hooks/query/useGetUsageRequest'

import { showYoutubeAuth, UserType } from 'utils/common'
import { GuideToUse } from 'components/GuideToUse'
import classNames from 'classnames'

import { PromotionCircle } from 'components/upgrade/PromotionCircle'
import useGetShortUsageRequest from 'hooks/query/useGetShortUsageRequest'
import { ShortsVideoDailyBarChart } from 'components/chart/DailyBarChart'

import { Modal } from 'components/layout/Modal'
import { TextAreaMyVideo } from 'components/atom/TextArea'
import { Controller, useForm } from 'react-hook-form'

import {
  EmptyPlan,
  FreePlan,
  LightPlan,
  ProAndPremiumPlanAnnual,
  ProAndPremiumPlanMonthly,
} from 'components/PlanDashBoard/PlanDashBoard'
import useCreateChallenge from 'hooks/query/challenge/useCreateChallenge'
import useGetChallenge from 'hooks/query/challenge/useGetChallenge'
import useUpdateChallenge from 'hooks/query/challenge/useUpdateChallenge'
import { ChallengeType } from 'service/challenge'
import useInsertLinkChallenge from 'hooks/query/challenge/useInsertLinkChallenge'
import { PlanPriceModal } from 'components/payment/PlanPriceModal'
import useUserStore from 'store/useUserStore'
import useGetTextContentRequest from 'hooks/query/useGetTextContentRequest'
import { FastclickDashBoard } from 'components/fastclick/FastclickDashBoard'
import { FastclickDescription } from 'components/fastclick/FastclickDescription'
import { AuthGuard } from 'components/gaurd/AuthGuard'
import { Helmet } from 'react-helmet-async'

import {
  VideoType,
  getVideoTypeDescription,
  getApiTypeByVideoType,
  getVideoTypeFromParam,
} from 'constant/videoTypes'
import { VideoGuideList } from './components/VideoGuideList'
import { subscriptionType } from 'service/plans'
import AiGeneratedTag from 'components/AiGeneratedTag'

export const VideoUsageHistory = () => {
  const userInfo = useUserStore((state: any) => state.userInfo)
  const userAgent = navigator.userAgent.toLowerCase()

  const location = useLocation()
  const navigate = useNavigate()
  const [totalItems, setTotalItems] = useState(0)
  const itemsPerPage = 10
  const [defaultPage, setDefaultPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const params = new URLSearchParams(location.search)
  const tType = params.get('type')

  let page = parseInt(params.get('page') || '', 10)

  const [tab, setTab] = useState(getVideoTypeFromParam(tType))
  const [dashboardTab, setDashboardTab] = useState(VideoType.PRODUCT_LONG)
  const [isPlanPriceModal, setPlanPriceModal] = useState<boolean>(false)
  const [linkSaveModal, setLinkSaveModal] = useState<boolean>(false)
  const [showRevenueModal, setShowRevenueModal] = useState<boolean>(false)
  const [failInfoModal, setFailInfoModal] = useState<boolean>(false)
  const [errorText, setErrorText] = useState({
    title: '',
    subtitle: <></>,
  })

  if (!page || isNaN(page) || page < 1) {
    page = defaultPage
    params.set('type', tab)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }
  //* 패스트컷 비디오 사용량(상품 롱폼)
  const {
    data: usageRequest,
    refetch: usageRefetch,
    isError,
  } = useGetUsageRequest(page, itemsPerPage)

  //* 링크 / 상품 숏폼
  const {
    data: shortUsageRequest,
    refetch: shortUsageRefetch,
    isError: isShortError,
  } = useGetShortUsageRequest(page, itemsPerPage, getApiTypeByVideoType(tab))

  //* 텍스트 비디오
  const {
    data: textContentUsageRequest,
    refetch: textContentUsageRefetch,
    isError: isTextContentError,
  } = useGetTextContentRequest(page, itemsPerPage)

  const { data: userPlanInfo } = useGetMePlan()

  // user의 영상생성 개수 불러오기

  const [usageList, setUsageList] = useState<UsageRequestFactor[] | []>([])
  const openStatusDialog = (fcStatus: string) => {
    if (['재시도', '생성 실패'].includes(fcStatus)) {
      if (fcStatus === '생성 실패') {
        setErrorText({
          title: '🙏 영상 생성 실패',
          subtitle: (
            <>
              링크, 이미지, 상품 등에 문제가 발행하여
              <br />
              영상 생성에 실패했습니다.
              <br />
              자세한 이유와 처리 안내 등은
              <br />
              가입하신 이메일로 설명 드렸으니
              <br />꼭 확인 부탁드립니다.
            </>
          ),
        })
      } else if (fcStatus === '재시도') {
        setErrorText({
          title: '🧑‍💻 영상 생성 재시도',
          subtitle: (
            <>
              링크, 이미지, 상품 등에 문제가 발행하여
              <br />
              영상 생성을 재시도 합니다.
              <br />
              시간이 조금 더 소요되는 점 양해 부탁드립니다.
            </>
          ),
        })
      }

      setFailInfoModal((prev: any) => !prev)
    }
  }
  const createTable = () => {
    if (isMobile) {
      return (
        <>
          <div
            className="rounded-b-[20px] md:rounded-tr-[20px] md:px-8 md:py-[40px]"
            style={{ border: '1px solid #EEF1F7' }}
          >
            <table className="min-w-full border-collapse py-4">
              <thead className="">
                <tr className="border-b text-center text-[#5E6068]">
                  <th className="w-[30px] px-2 py-5">NO</th>
                  <th className="px-2 py-5 text-left">제목</th>
                  <th className="w-[79px] px-1 py-5">상태</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-[#EBF4FF] text-center text-[#5E6068]">
                  <td className="text-[20px]">💁🏻</td>
                  <td className="text-[14px]">
                    생성 완료 영상 스마트폰 다운로드는
                    <br />
                    구글드라이브 앱에서만 가능합니다!
                  </td>
                  <td className="">
                    <a
                      className="a flex items-center gap-1 rounded-full bg-white px-2 py-2 text-[12px]"
                      href={
                        userAgent.includes('android')
                          ? 'https://play.google.com/store/apps/details?id=com.google.android.apps.docs&hl=ko'
                          : 'https://apps.apple.com/kr/app/google-%EB%93%9C%EB%9D%BC%EC%9D%B4%EB%B8%8C-%EC%95%88%[…]%8C%EC%9D%BC-%EC%A0%80%EC%9E%A5%EA%B3%B5%EA%B0%84/id507874739'
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src="assets/img/drive.png" alt="drive" />
                      {`앱 설치 >`}
                    </a>
                  </td>
                </tr>
                {usageList.length > 0 ? (
                  <>
                    {usageList.map((el, index) => {
                      const {
                        mainTitle,
                        createdAt: requestedAt,
                        contentCreatedAt,
                        uploadedAt,
                        driveLink,
                        type,
                        status,
                      } = el

                      return (
                        <>
                          <tr className="text-center text-[#5E6068]">
                            <td
                              className={`px-1 align-top ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              {totalItems &&
                                (totalItems - itemsPerPage * (page - 1) - index)
                                  .toString()
                                  .padStart(2, '0')}
                            </td>

                            <td
                              className={`px-1 text-left align-top ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              {mainTitle !== ''
                                ? mainTitle
                                : '영상 생성 준비중...'}
                            </td>
                            <td
                              className={`flex h-[24px] items-start px-1 text-left align-top ${
                                index === 0 ? 'py-[24px]' : 'pb-[24px]'
                              }`}
                            >
                              <a
                                href={driveLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button
                                  className={`flex h-[24px] w-[79px] items-center justify-center gap-[4px] rounded-[20px] text-[12px] font-bold text-[#FFFFFF] ${
                                    driveLink && 'active:scale-95'
                                  } ${status === '생성 대기' && 'bg-[#C4DFFF]'} ${status === '재시도' && 'bg-[#FF8800]'} ${status === '생성 실패' && 'bg-[#2E343D]'} ${status === '생성 완료' && 'bg-[#3A8FF2]'} ${status === '등록 완료' && 'bg-[#464DEE]'} `}
                                  onClick={() => {
                                    openStatusDialog(status)
                                  }}
                                >
                                  <span>{status} </span>{' '}
                                  {['재시도', '생성 실패'].includes(status) &&
                                    '>'}
                                  {driveLink && (
                                    <img
                                      src="assets/img/icon_cloud.png"
                                      alt="cloud"
                                      height={14}
                                      width={14}
                                    />
                                  )}
                                </button>
                              </a>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {' '}
                    <tr>
                      <td
                        colSpan={6}
                        rowSpan={10}
                        className="py-[80px] text-center"
                      >
                        <p className="text-[18px] font-bold leading-[28px]">
                          아직 생성 요청하신{' '}
                          {tab === VideoType.PRODUCT_LONG ||
                          tab === VideoType.PRODUCT_SHORT
                            ? '영상'
                            : '컨텐츠 영상'}
                          이 없어요!
                          <br />
                          {getVideoTypeDescription(tab)}
                          <br />
                          <span className="text-main">
                            <button
                              onClick={() => {
                                tab === VideoType.PRODUCT_LONG ||
                                tab === VideoType.PRODUCT_SHORT
                                  ? navigate('/video-editor')
                                  : navigate(
                                      `/short-video-editor?createType=${
                                        tab === VideoType.LINK_CONTENT
                                          ? 'link'
                                          : 'text'
                                      }`,
                                    )
                              }}
                            >
                              {tab === VideoType.PRODUCT_LONG ||
                              tab === VideoType.PRODUCT_SHORT
                                ? '상품 영상 만들러 가기 >>'
                                : '컨텐츠 영상 만들러 가기 >>'}
                            </button>
                          </span>
                        </p>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagenation mt-3 flex justify-center gap-[4px]">
            <button
              className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
              onClick={() => handlePageEndChange(1)}
              disabled={currentPage === 1}
            >
              <img src="assets/img/icon_arrow_left_end.png" alt="icon" />
            </button>
            <button
              className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <img src="assets/img/icon_arrow_left.png" alt="icon" />
            </button>
            {renderPageNumbers()}
            <button
              className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <img src="assets/img/icon_arrow_right.png" alt="icon" />
            </button>
            <button
              className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
              disabled={currentPage === totalPages}
              onClick={() => {
                handlePageEndChange(totalPages)
              }}
            >
              <img src="assets/img/icon_arrow_right_end.png" alt="icon" />
            </button>
          </div>
        </>
      )
    } else {
      return (
        <>
          <div
            className="w-full md:rounded-b-[20px] md:rounded-tr-[20px] md:px-8 md:py-[40px]"
            style={{ border: '1px solid #EEF1F7' }}
          >
            <table className="min-w-full border-collapse">
              <thead className="">
                <tr className="border-b text-center text-[#5E6068]">
                  <th className="w-[30px] px-2 pb-5">NO</th>

                  <th className="px-2 pb-5 text-left">제목</th>
                  <th className="w-[42px] px-1 pb-5">요청</th>
                  <th className="w-[42px] px-1 pb-5">생성</th>

                  <th className="w-[42px] px-1 pb-5">등록</th>

                  <th className="w-[79px] px-1 pb-5">상태</th>
                </tr>
              </thead>
              <tbody className="">
                {usageList?.length > 0 ? (
                  <>
                    {usageList.map((el, index) => {
                      const {
                        mainTitle,
                        createdAt: requestedAt,
                        uploadedAt,
                        contentCreatedAt,
                        driveLink,
                        type,
                        status,
                      } = el

                      return (
                        <>
                          <tr className="text-center text-[#5E6068]">
                            <td className="p-[12px] px-1">
                              {totalItems &&
                                (totalItems - itemsPerPage * (page - 1) - index)
                                  .toString()
                                  .padStart(2, '0')}
                            </td>

                            <td className="p-[12px] px-1 text-left">
                              {mainTitle !== ''
                                ? mainTitle
                                : '영상 생성 준비중...'}
                            </td>
                            <td className="request p-[12px] px-1">
                              {requestedAt}
                            </td>
                            <td className="create p-[12px] px-1">
                              {contentCreatedAt}
                            </td>

                            <td className="upload p-[12px] px-1">
                              {uploadedAt}
                            </td>

                            <td className="h-[24px] p-[12px] px-1">
                              <a
                                href={driveLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <button
                                  className={`flex h-[24px] w-[79px] items-center justify-center gap-[4px] rounded-[20px] text-[12px] font-bold text-[#FFFFFF] ${driveLink && 'active:scale-95'} ${
                                    status === '생성 대기' && 'bg-[#C4DFFF]'
                                  } ${status === '재시도' && 'bg-[#FF8800]'} ${status === '생성 실패' && 'bg-[#2E343D]'} ${
                                    status === '생성 완료' && 'bg-[#3A8FF2]'
                                  } ${
                                    status === '등록 완료' && 'bg-[#464DEE]'
                                  } `}
                                  onClick={() => {
                                    openStatusDialog(status)
                                  }}
                                >
                                  <span>{status}</span>{' '}
                                  {['재시도', '생성 실패'].includes(status) &&
                                    '>'}
                                  {driveLink && (
                                    <img
                                      src="assets/img/icon_cloud.png"
                                      alt="cloud"
                                      height={14}
                                      width={14}
                                    />
                                  )}
                                </button>
                              </a>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                  </>
                ) : (
                  <>
                    {' '}
                    <tr>
                      <td
                        colSpan={6}
                        rowSpan={10}
                        className="py-[80px] text-center"
                      >
                        <p className="text-[18px] font-bold leading-[28px]">
                          아직 생성 요청하신{' '}
                          {tab === VideoType.PRODUCT_LONG ||
                          tab === VideoType.PRODUCT_SHORT
                            ? '영상'
                            : '컨텐츠 영상'}
                          이 없어요!
                          <br />
                          {getVideoTypeDescription(tab)}
                          <br />
                          <span className="text-main">
                            <button
                              onClick={() => {
                                tab === VideoType.PRODUCT_LONG ||
                                tab === VideoType.PRODUCT_SHORT
                                  ? navigate('/video-editor')
                                  : navigate(
                                      `/short-video-editor?createType=${
                                        tab === VideoType.LINK_CONTENT
                                          ? 'link'
                                          : 'text'
                                      }`,
                                    )
                              }}
                            >
                              {tab === VideoType.PRODUCT_LONG ||
                              tab === VideoType.PRODUCT_SHORT
                                ? '상품 영상 만들러 가기 >>'
                                : '컨텐츠 영상 만들러 가기 >>'}
                            </button>
                          </span>
                        </p>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
              {/* <div className="w-full">
               
              </div> */}
            </table>
            <div className="pagenation flex justify-center gap-[4px]">
              <button
                className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
                onClick={() => handlePageEndChange(1)}
                disabled={currentPage === 1}
              >
                <img src="assets/img/icon_arrow_left_end.png" alt="icon" />
              </button>
              <button
                className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <img src="assets/img/icon_arrow_left.png" alt="icon" />
              </button>
              {renderPageNumbers()}
              <button
                className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <img src="assets/img/icon_arrow_right.png" alt="icon" />
              </button>
              <button
                className="flex h-[32px] w-[32px] items-center justify-center border-[1px] border-[#DFE3E8] text-[14px] font-bold disabled:bg-[#EEF1F7]"
                disabled={currentPage === totalPages}
                onClick={() => {
                  handlePageEndChange(totalPages)
                }}
              >
                <img src="assets/img/icon_arrow_right_end.png" alt="icon" />
              </button>
            </div>
          </div>
        </>
      )
    }
  }

  const renderPageNumbers = () => {
    const pagesPerBlock = 10
    const pageNumbers = []
    const currentBlock = Math.floor((currentPage - 1) / pagesPerBlock)
    const startPage = currentBlock * pagesPerBlock + 1
    const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages)

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          className={classNames(
            `flex h-[32px] w-[32px] items-center justify-center border-[1px] text-[14px] font-bold`,
            {
              'border-main text-main': currentPage === i,
              'border-[#DFE3E8]': currentPage !== i,
            },
          )}
          key={i}
          onClick={() => handlePageChange(i)}
          disabled={currentPage === i}
        >
          {i}
        </button>,
      )
    }

    return pageNumbers
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    const params = new URLSearchParams(location.search)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }
  const handlePageEndChange = (page: number) => {
    setCurrentPage(page)
    const params = new URLSearchParams(location.search)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }

  const handleTab = (type: VideoType) => {
    setTab(type)
  }
  const handleDashboardTab = (type: string) => {
    setDashboardTab(VideoType.PRODUCT_LONG)
  }

  const chartElByTab = () => {
    if (dashboardTab === VideoType.LINK_CONTENT) {
      return (
        <>
          <div className="relative flex h-[210px] w-full flex-col justify-evenly rounded-[10px] bg-white p-5 md:w-[474px]">
            <p className="font-bold">2024. 11월</p>

            <ShortsVideoDailyBarChart barWidth={isMobile ? 4 : 8} />
            <div className="absolute h-full w-full bg-white opacity-50"></div>
            <div className="absolute left-[37.5%] top-[50%] flex h-[37px] w-[87px] items-center justify-center rounded-[8px] border-[2px] border-[#D9DEE8] bg-white text-[14px] font-bold md:left-[45%]">
              <p className="z-50 text-center">기능 준비중</p>
            </div>
          </div>
          <div className="flex w-full items-center justify-evenly rounded-[20px] bg-white p-5 md:w-[248px]">
            <div className="items flex flex-col items-center gap-2">
              <p
                className={classNames(
                  'flex items-center justify-center bg-[#C4DFFF]',
                  {
                    'h-[50px] w-[50px] rounded-[100px]':
                      userInfo?.fastCutShortUsageSummary[0]?.ready.length ??
                      0 < 3,
                    'h-[50px] w-[70px] rounded-[50px]':
                      userInfo?.fastCutShortUsageSummary[0]?.ready.length >= 3,
                  },
                )}
              >
                <span className="text-[24px] font-bold text-white">
                  {userInfo?.fastCutShortUsageSummary[0]?.ready ?? 0}
                </span>
              </p>

              <p className="font-bold">생성 대기</p>
            </div>
            <div className="items flex flex-col items-center gap-2">
              <p
                className={classNames(
                  'flex items-center justify-center bg-[#3A8FF2]',
                  {
                    'h-[50px] w-[50px] rounded-[100px]':
                      userInfo?.fastCutShortUsageSummary[0]?.complete.length ??
                      0 < 3,
                    'h-[50px] w-[70px] rounded-[50px]':
                      userInfo?.fastCutShortUsageSummary[0]?.complete.length >=
                      3,
                  },
                )}
              >
                <span className="text-[24px] font-bold text-white">
                  {' '}
                  {userInfo?.fastCutShortUsageSummary[0]?.complete ?? 0}
                </span>
              </p>
              <p className="font-bold">생성 완료</p>
            </div>
          </div>
        </>
      )
    } else if (dashboardTab === VideoType.PRODUCT_LONG) {
      return (
        <>
          {userInfo?.userType === UserType.라이트 && (
            <>
              <LightPlan
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                subscriptions={userPlanInfo?.subscriptions}
                monthStart={userPlanInfo?.subscriptions.monthStart ?? '--'}
                monthEnd={userPlanInfo?.subscriptions.monthEnd ?? '--'}
              />
            </>
          )}
          {(userInfo?.userType === UserType.프로 ||
            userInfo?.userType === UserType.프리미엄 ||
            userInfo?.userType === UserType['숏폼 스페셜']) &&
          userInfo?.subscriptions?.subscriptionType === 'annual' ? (
            <>
              <ProAndPremiumPlanAnnual
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.monthStart ?? '--'}
                endDate={userPlanInfo?.subscriptions?.monthEnd ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                available={userPlanInfo?.usage?.available ?? false}
                couponBenefit={userInfo?.couponBenefit}
                isDone={userPlanInfo?.usage?.isDone}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          ) : (
            (userInfo?.userType === UserType.프로 ||
              userInfo?.userType === UserType.프리미엄 ||
              userInfo?.userType === UserType['숏폼 스페셜']) &&
            userInfo?.subscriptions?.subscriptionType === 'monthly' && (
              <>
                {' '}
                <ProAndPremiumPlanMonthly
                  userType={userInfo?.userType}
                  subscriptionType={
                    userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                  }
                  startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                  endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                  currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                  available={userPlanInfo?.usage?.available ?? false}
                  isDone={userPlanInfo?.usage?.isDone}
                  couponBenefit={userInfo?.couponBenefit}
                  subscriptions={userPlanInfo?.subscriptions}
                />
              </>
            )
          )}
          {userInfo?.userType === UserType.USER && (
            <>
              <EmptyPlan
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                setPlanPriceModal={setPlanPriceModal}
              />
            </>
          )}
          {userInfo?.userType === UserType.체험 && (
            <>
              <FreePlan
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
                usedCount={userPlanInfo?.usage?.usedCount ?? 0}
                available={userPlanInfo?.usage?.available ?? false}
                couponBenefit={userInfo?.couponBenefit}
                isDone={userPlanInfo?.usage?.isDone}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          )}
        </>
      )
    } else {
      return null
    }
  }

  const handleChallengeBtn = () => {
    if (
      dashboardTab === VideoType.PRODUCT_LONG &&
      userInfo?.challenge &&
      userPlanInfo?.subscriptions?.round &&
      userInfo?.challenge?.status === 'active' &&
      (userPlanInfo?.subscriptions?.planId === 2 ||
        userPlanInfo?.subscriptions?.planId === 3) &&
      userPlanInfo?.subscriptions?.subscriptionType === subscriptionType.ANNUAL
    ) {
      if (userPlanInfo?.subscriptions?.round <= 3) {
        return (
          <div className="">
            <button
              className="flex h-[36px] w-[343px] items-center justify-center gap-1 rounded-[20px] bg-[#735CFF] text-[14px] font-bold text-[white] md:w-[156px]"
              onClick={() => {
                setLinkSaveModal((prev) => !prev)
              }}
            >
              <span>✋챌린지 참여 선언</span>
            </button>
          </div>
        )
      } else if (userPlanInfo?.subscriptions?.round > 3) {
        return (
          <div className="">
            <button
              className="flex h-[36px] w-[343px] items-center justify-center gap-1 rounded-[20px] bg-[#007A7B] text-[14px] font-bold text-[white] md:w-[116px]"
              onClick={() => {
                setShowRevenueModal((prev) => !prev)
              }}
            >
              <img src="assets/img/money.png" alt="" width={20} height={20} />
              <span>수익 인증</span>
            </button>
          </div>
        )
      }
    }
  }
  useEffect(() => {
    if (usageRequest && tab === VideoType.PRODUCT_LONG) {
      setUsageList(usageRequest.data)
      setTotalItems(usageRequest.totalCount)
    }
    if (isShortError && tab === VideoType.LINK_CONTENT) {
      setUsageList([])
      setTotalItems(0)
    }
    if (shortUsageRequest && tab === VideoType.LINK_CONTENT) {
      setUsageList(shortUsageRequest.data)
      setTotalItems(shortUsageRequest.totalCount)
    }
    if (isError && tab === VideoType.PRODUCT_LONG) {
      setUsageList([])
      setTotalItems(0)
    }
    if (shortUsageRequest && tab === VideoType.PRODUCT_SHORT) {
      setUsageList(shortUsageRequest.data)
      setTotalItems(shortUsageRequest.totalCount)
    }
    if (isShortError && tab === VideoType.PRODUCT_SHORT) {
      setUsageList([])
      setTotalItems(0)
    }
    if (textContentUsageRequest && tab === VideoType.TEXT_CONTENT) {
      setUsageList(textContentUsageRequest.data)
      setTotalItems(textContentUsageRequest.totalCount)
    }
    if (isTextContentError && tab === VideoType.TEXT_CONTENT) {
      setUsageList([])
      setTotalItems(0)
    }
  }, [usageRequest, shortUsageRequest, textContentUsageRequest, tab])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const page = parseInt(params.get('page') || '', 10)
    if (page && tab === VideoType.PRODUCT_LONG) {
      setCurrentPage(page)
      usageRefetch()
    } else if (page && tab === VideoType.LINK_CONTENT) {
      setCurrentPage(page)
      shortUsageRefetch()
    } else if (page && tab === VideoType.PRODUCT_SHORT) {
      setCurrentPage(page)
      shortUsageRefetch()
    } else if (page && tab === VideoType.TEXT_CONTENT) {
      setCurrentPage(page)
      textContentUsageRefetch()
    }
  }, [location.search])

  useEffect(() => {
    console.log(tab, '1`23')
    let page = 1
    params.set('type', tab)
    params.set('page', page.toString())
    params.set('pageSize', itemsPerPage.toString())
    navigate({ search: params.toString() })
  }, [tab])
  useEffect(() => {
    const userType = userInfo?.userType
    if (userType && userType === UserType['숏폼 스페셜']) {
      setTab(VideoType.PRODUCT_SHORT)
    }
  }, [userInfo])
  return (
    <>
      <Helmet>
        <title>사용 현황</title>
        <meta
          name="description"
          content="내가 생성 요청한 영상들의 진행 상태와 다운로드 가능 여부를 확인하세요."
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/my-videos"
        />
      </Helmet>
      <div className="mx-auto my-0 flex min-h-[100vh] w-[375px] flex-col items-center px-4 md:w-[816px]">
        <div className="flex w-[343px] flex-col gap-6 md:w-[816px]">
          {/* {!isMobile && (
          <My>
            <p>사용 현황</p>
          </My>
        )} */}
          <div className="flex justify-center">
            <p className="text-[24px] font-bold md:text-[40px]">사용 현황</p>
          </div>
          <div className="my-videos tab flex w-[343px] flex-col md:w-[816px]">
            <div className="flex flex-col-reverse items-end text-[18px] md:flex-row md:items-center">
              <div className="mt-6 flex w-full md:mt-0">
                <button
                  className={classNames(
                    'flex h-[54px] w-[171.5px] items-center justify-center rounded-t-[20px] md:w-[200px]',
                    {
                      'bg-[#F6F8FB]': dashboardTab === VideoType.PRODUCT_LONG,
                      'bg-[#EEF1F7] text-[#B6BBC6]':
                        dashboardTab !== VideoType.PRODUCT_LONG,
                    },
                  )}
                  onClick={() => {
                    handleDashboardTab(VideoType.PRODUCT_LONG)
                  }}
                >
                  <p className="font-bold">상품 영상</p>
                </button>
                {/* <button
                className={classNames(
                  'md:w-[200px] w-[171.5px] h-[54px] flex items-center justify-center  rounded-tr-[20px]',
                  {
                    'bg-[#F6F8FB]': dashboardTab === VideoType.LINK_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      dashboardTab !== LINK_CONTENT_VIDEO,
                  }
                )}
                onClick={() => {
                  handleDashboardTab(LINK_CONTENT_VIDEO)
                }}
              >
                <p className="font-bold ">컨텐츠 영상</p>
              </button> */}
              </div>
              <div className="flex w-full flex-col items-center justify-center gap-[6px] md:ml-2 md:flex-row md:items-start md:justify-start">
                {handleChallengeBtn()}
                {dashboardTab === VideoType.PRODUCT_LONG && (
                  <>
                    {' '}
                    {showYoutubeAuth(
                      userInfo,
                      'flex justify-center items-center md:w-[248px] md:h-[36px] w-[343px] h-[46px] bg-error text-white font-bold text-[14px] rounded-[40px]',
                    )}
                  </>
                )}
                {dashboardTab === VideoType.PRODUCT_LONG && isMobile && (
                  <>
                    <PromotionCircle
                      userInfo={userInfo}
                      planId={userInfo?.subscriptionType?.planId}
                      classNameProps="w-full h-[46px]  rounded-full text-white font-bold"
                    />
                  </>
                )}
              </div>
            </div>

            <div
              className={classNames(
                'flex w-[343px] flex-col rounded-b-[20px] bg-[#F6F8FB] p-[10px] md:w-full md:rounded-tr-[20px] md:px-10 md:py-8',
                {
                  '-[20px] rounded-tr': isMobile,
                },
              )}
            >
              <div className="name mb-2">
                {userInfo?.userInfo?.name}
                {` `}({userInfo?.userInfo?.email}){` `}님
              </div>
              <div className="relative flex w-full flex-col gap-4 md:flex-row md:justify-between">
                {chartElByTab()}
              </div>
              <AuthGuard userInfo={userInfo}>
                <FastclickDashBoard userInfo={userInfo} blockWidth="w-full" />
              </AuthGuard>
            </div>
          </div>
          {dashboardTab === VideoType.PRODUCT_LONG && !isMobile && (
            <>
              <div className="flex justify-center">
                <PromotionCircle
                  userInfo={userInfo}
                  planId={userInfo?.subscriptionType?.planId}
                  classNameProps="w-full h-[46px]  rounded-full text-white font-bold"
                />
              </div>
            </>
          )}
          <div className="list flex w-full flex-col">
            <div className="relative mt-6 flex text-[14px] md:mt-0 md:text-base">
              <div className="absolute right-0 top-2">
                <AiGeneratedTag text="AI로 생성된 결과물 입니다." />
              </div>
              {userInfo?.userType !== UserType['숏폼 스페셜'] && (
                <button
                  className={classNames(
                    'flex h-[54px] w-[171.5px] items-center justify-center rounded-tl-[20px] md:w-[140px]',
                    {
                      'border-l-[1px] border-t-[1px]':
                        tab === VideoType.PRODUCT_LONG,
                      'bg-[#EEF1F7] text-[#B6BBC6]':
                        tab !== VideoType.PRODUCT_LONG,
                    },
                  )}
                  onClick={() => {
                    handleTab(VideoType.PRODUCT_LONG)
                  }}
                >
                  <p className="font-bold">상품 롱폼</p>
                </button>
              )}
              <button
                className={classNames(
                  'flex h-[54px] w-[171.5px] items-center justify-center md:w-[140px]',
                  {
                    'border-l-[1px] border-t-[1px]':
                      tab === VideoType.PRODUCT_SHORT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.PRODUCT_SHORT,
                    'rounded-tl-[20px]':
                      userInfo?.userType === UserType['숏폼 스페셜'],
                  },
                )}
                onClick={() => {
                  handleTab(VideoType.PRODUCT_SHORT)
                }}
              >
                <p className="font-bold">상품 숏폼</p>
              </button>
              <button
                className={classNames(
                  'flex h-[54px] w-[171.5px] items-center justify-center md:w-[140px]',
                  {
                    'border-r-[1px] border-t-[1px]':
                      tab === VideoType.LINK_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.LINK_CONTENT,
                  },
                )}
                onClick={() => {
                  handleTab(VideoType.LINK_CONTENT)
                }}
              >
                <p className="font-bold">링크 컨텐츠</p>
              </button>
              <button
                className={classNames(
                  'flex h-[54px] w-[171.5px] items-center justify-center rounded-tr-[20px] md:w-[140px]',
                  {
                    'border-r-[1px] border-t-[1px]':
                      tab === VideoType.TEXT_CONTENT,
                    'bg-[#EEF1F7] text-[#B6BBC6]':
                      tab !== VideoType.TEXT_CONTENT,
                  },
                )}
                onClick={() => {
                  handleTab(VideoType.TEXT_CONTENT)
                }}
              >
                <p className="font-bold">텍스트 컨텐츠</p>
              </button>
            </div>
            <div>{createTable()}</div>
          </div>
          {(tab === VideoType.PRODUCT_SHORT ||
            tab === VideoType.PRODUCT_LONG) && (
            <FastclickDescription userInfo={userInfo} />
          )}

          <div className="">
            {' '}
            <VideoGuideList videoType={tab} />
          </div>
          <div className="flex justify-center">
            <GuideToUse />
          </div>
          <AuthSaveLinkModal
            linkSaveModal={linkSaveModal}
            setLinkSaveModal={setLinkSaveModal}
          />
          <RevenueModal
            showRevenueModal={showRevenueModal}
            setShowRevenueModal={setShowRevenueModal}
          />
          <FailInfoModal
            failInfoModal={failInfoModal}
            setFailInfoModal={setFailInfoModal}
            errorText={errorText}
          />
          {isPlanPriceModal && (
            <PlanPriceModal
              isPlanPriceModal={isPlanPriceModal}
              setPlanPriceModal={setPlanPriceModal}
              userInfo={userInfo}
            />
          )}
        </div>
      </div>
    </>
  )
}

const AuthSaveLinkModal = (props: any) => {
  const { linkSaveModal, setLinkSaveModal } = props

  const [challenge, setChallenge] = useState<ChallengeType | null>(null)
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      link: '',
    },
  })
  const [text, setText] = useState<string>('저장')
  const { data, isPending: getChallengePending, refetch } = useGetChallenge()
  const { mutate: updateMutate, isPending: updatePending } =
    useUpdateChallenge()
  const { mutate: createMutate, isPending: createPending } =
    useCreateChallenge()
  const handleCreateChallenge = (data: any) => {
    const { link } = data
    if (challenge) {
      updateMutate(
        { link, id: challenge.id },
        {
          onSuccess: () => {
            setText('저장됨')
            refetch()
          },
          onError: () => {
            console.log('challenge 업데이트 실패')
          },
        },
      )
    } else {
      createMutate(data, {
        onSuccess: () => {
          setText('저장됨')
          refetch()
        },
        onError: () => {
          console.log('challenge 생성 실패')
        },
      })
    }
  }

  useEffect(() => {
    if (data) {
      setChallenge(data)
      setText('저장됨')
      setValue('link', data.link)
    }
  }, [data, linkSaveModal])

  return (
    <>
      {' '}
      {linkSaveModal && (
        <Modal isModal={linkSaveModal}>
          <form
            onSubmit={handleSubmit(handleCreateChallenge, (err) => {
              console.log(err)
            })}
          >
            <div className="flex h-[350px] w-[330px] flex-col gap-6 overflow-auto rounded-t-[20px] border-t bg-white px-5 pt-8">
              <div className="flex flex-col gap-6">
                <p className="text-[18px] font-bold">챌린지 참여 선언</p>
                <div>
                  <p className="text-left">
                    유튜브 영상 링크나 블로그 포스트 링크를 입력하고
                    저장해주세요.
                  </p>
                  <p className="text-left text-error">
                    참여 선언을 완료해야 수익인증 기능이 활성화 됩니다.
                  </p>
                </div>
              </div>
              <div className="h-auto pb-8">
                <div className="relative">
                  <Controller
                    render={({ field: { onBlur, value, ...field } }) => (
                      <>
                        <TextAreaMyVideo
                          value={value}
                          {...field}
                          placeholder="참여선언 한 블로그나 유튜브 링크 입력"
                          className={classNames('bg-[#F6F8FB]', {
                            'text-[#8F929B]': text === '저장됨',
                          })}
                          disabled={createPending || text === '저장됨'}
                        />
                      </>
                    )}
                    name={'link'}
                    rules={{
                      required: {
                        value: true,
                        message: 'Link 입력은 필수입니다!',
                      },
                    }}
                    control={control}
                  />
                  <div className="absolute -bottom-14 right-2 top-0 flex items-center gap-[16px]">
                    <button
                      type="button"
                      onClick={() => {
                        setValue('link', '')
                        setText('적용')
                      }}
                      disabled={createPending}
                    >
                      <img
                        className="h-[32px] w-[32x]"
                        src="assets/img/icon_circle_x.png"
                        alt="x"
                      />
                    </button>
                    <button
                      className={classNames(
                        'flex h-[43px] w-[76px] items-center justify-center rounded-[10px] bg-[#6B8ACB] font-bold text-white hover:bg-[#8FABE5] disabled:opacity-[0.3]',
                        {
                          'active:scale-95': text === '적용',
                        },
                      )}
                      disabled={createPending || text === '저장됨'}
                    >
                      {text}
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <img src="assets/img/challenge/3step.png" alt="" />
              </div>
            </div>
            <div className="flex h-[60px] w-[330px] items-center justify-center text-[14px] font-bold">
              <button
                className="h-full w-[50%] rounded-bl-[20px] border-b border-[#EEF1F7] bg-[#EEF1F7] text-black"
                onClick={() => {
                  setLinkSaveModal(false)
                }}
                disabled={createPending}
                type="button"
              >
                취소
              </button>
              <button
                className="h-full w-[50%] rounded-br-[20px] border-b border-main bg-main text-white"
                onClick={() => {
                  setLinkSaveModal(false)
                }}
                disabled={createPending}
                type="button"
              >
                확인
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  )
}

const FailInfoModal = (props: any) => {
  const { failInfoModal, setFailInfoModal, errorText } = props

  return (
    <>
      {' '}
      {failInfoModal && (
        <Modal isModal={failInfoModal}>
          <div className="h-[230px] w-[400px] rounded-t-[20px] border-t bg-white p-[20px]">
            <div className="flex h-full flex-col items-center justify-center gap-[24px]">
              <p className="text-[18px] font-bold">{errorText.title}</p>
              <div className="flex flex-col leading-[22px]">
                <p className="text-[14px]">{errorText.subtitle}</p>
              </div>
            </div>
          </div>
          <div className="flex h-[60px] w-[400px] items-center justify-center text-[14px]">
            <button
              className="h-full w-[100%] rounded-b-[20px] border-b border-main bg-main font-bold text-white"
              onClick={() => {
                setFailInfoModal((prev: any) => !prev)
              }}
            >
              확인
            </button>
          </div>
        </Modal>
      )}
    </>
  )
}

const RevenueModal = (props: any) => {
  const [challenge, setChallenge] = useState<ChallengeType | null>(null)
  const [text, setText] = useState<string>('저장')
  const [day, setDay] = useState<number>(new Date().getDate())
  const [isOpenDay, setOpenDay] = useState<boolean>(false)

  const { mutate: updateMutate, isPending: updatePending } =
    useUpdateChallenge()
  const { mutate: createMutate, isPending: createPending } =
    useCreateChallenge()
  const handleCreateChallenge = () => {
    const link = watch('link')
    if (challenge) {
      updateMutate(
        { link, id: challenge.id },
        {
          onSuccess: () => {
            setText('저장됨')
            refetch()
          },
          onError: () => {
            console.log('challenge 업데이트 실패')
          },
        },
      )
    } else {
      createMutate(data, {
        onSuccess: () => {
          setText('저장됨')
          refetch()
        },
        onError: () => {
          console.log('challenge 생성 실패')
        },
      })
    }
  }

  const { showRevenueModal, setShowRevenueModal } = props

  const [textList, setTextList] = useState(new Array(18).fill('적용'))
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      link: '',
      challengeDetail: [
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
        { id: 0, link: '' },
      ],
    },
  })
  const { data, isPending: getChallengePending, refetch } = useGetChallenge()
  const { userInfo } = useUserStore()

  const { mutate, isPending } = useInsertLinkChallenge()
  const handleUpdateChallengeDetail = (index: number) => {
    if (day === 1 || day === 15) {
    } else {
      // 1, 15일 아니면 안된다고 모달을 띄워야 함
      setOpenDay(true)
      return
    }
    const link = watch(`challengeDetail.${index}.link`)
    const id = watch(`challengeDetail.${index}.id`)

    mutate(
      { challengeDetailId: id, link },
      {
        onSuccess: () => {
          refetch()
          console.log('challenge detail 업데이트 성공')
        },
        onError: () => {
          console.log('challenge detail 업데이트 실패')
        },
      },
    )
  }
  const handleTextList = (index: number) => {
    const updateTextList = textList.map((el, i) =>
      i === index ? '적용' : textList[i],
    )

    setTextList(updateTextList)
  }

  const isFinishChallenge = () => {
    // 예시 형식 2025-10-10
    const endDate = userInfo?.subscriptions?.endDate
    const isChallenge = !!userInfo?.challenge

    if (!isChallenge || !endDate) return false

    const endDateObj = new Date(endDate)
    const today = new Date()
    const oneMonthFromNow = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000)
    console.log(oneMonthFromNow)

    return endDateObj <= oneMonthFromNow && endDateObj >= today
  }

  useEffect(() => {
    if (data) {
      setChallenge(data)
      setValue('link', data.link)
      setText('저장됨')
      data.challengeDetail.forEach((el, index) => {
        if (el.link) {
          const updateList = textList
          updateList[index] = '저장됨'

          setTextList(updateList)
        }
        setValue(`challengeDetail.${index}.link`, el.link)
        setValue(`challengeDetail.${index}.id`, el.id)
      })
    }
  }, [data, showRevenueModal])

  return (
    <>
      {' '}
      {showRevenueModal && (
        <Modal isModal={showRevenueModal}>
          <div className="flex max-h-[600px] w-[330px] flex-col gap-4 overflow-y-scroll rounded-t-[20px] border-t bg-white px-5 pt-8 md:max-h-[600px]">
            <div className="flex flex-col gap-6">
              <p className="text-[18px] font-bold">수익 인증</p>
              <div>
                <p className="text-left">
                  유튜브 영상 링크나 블로그 포스트 링크를 입력
                </p>
                <p className="text-left text-error">
                  참여 선언을 완료해야 수익인증 기능이 활성화 됩니다.
                </p>

                <div className="mt-2 flex flex-col items-start rounded-[10px] bg-[#2E343D] p-[10px]">
                  {' '}
                  <p className="font-bold text-main">💡 꼭 지켜주세요!</p>
                  <ul className="ml-6 flex list-disc flex-col items-start text-white">
                    <li>3라운드까지 미션 성공 후 4라운드부터</li>
                    <li className="text-error">
                      매월 1일 / 15일에 작성 후 링크 저장
                    </li>
                    <li>챌린지 페이지의 수익인증 가이드 준수</li>
                  </ul>
                </div>
                {isFinishChallenge() && (
                  <div>
                    <button
                      className="mt-2 flex h-[36px] w-full items-center justify-center gap-1 rounded-[20px] bg-[#007A7B] text-[14px] font-bold text-[white]"
                      onClick={() => {
                        window.open(
                          'https://forms.gle/BkGQgydy9vxDcfP97',
                          '_blank',
                        )
                      }}
                    >
                      <img
                        src="assets/img/money.png"
                        alt=""
                        width={20}
                        height={20}
                      />
                      <span>챌린지 페이백 신청하기</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex h-auto flex-col gap-6">
              {challenge?.challengeDetail.map((el, index) => {
                return (
                  <div className="relative flex flex-col items-start gap-2">
                    <p>
                      {' '}
                      <span className="font-bold">인증 {index + 1}</span>{' '}
                      <span>(1일, 15일 작성/저장만 유효)</span>
                    </p>

                    <Controller
                      render={({ field: { onBlur, value, ...field } }) => (
                        <>
                          <TextAreaMyVideo
                            value={value}
                            {...field}
                            placeholder="수익인증 한 블로그나 유튜브 링크 입력 해당 라운드 1일, 15일 작성/저장만 유효"
                            className={classNames('bg-[#F6F8FB]', {
                              'text-[#8F929B]': textList[index] === '저장됨',
                            })}
                            disabled={isPending || textList[index] === '저장됨'}
                          />
                        </>
                      )}
                      name={`challengeDetail.${index}.link`}
                      control={control}
                    />
                    <div className="absolute -bottom-24 right-2 top-0 flex items-center gap-[16px]">
                      <button
                        type="button"
                        onClick={() => {
                          setValue(`challengeDetail.${index}.link`, '')
                          handleTextList(index)
                        }}
                        disabled={isPending}
                      >
                        <img
                          className="h-[32px] w-[32x]"
                          src="assets/img/icon_circle_x.png"
                          alt="x"
                        />
                      </button>
                      <button
                        className={classNames(
                          'flex h-[43px] w-[74px] items-center justify-center rounded-[10px] bg-[#6B8ACB] font-bold text-white hover:bg-[#8FABE5] disabled:opacity-[0.3]',
                          {
                            'active:scale-95': textList[index] === '적용',
                          },
                        )}
                        disabled={isPending || textList[index] === '저장됨'}
                        onClick={() => {
                          handleUpdateChallengeDetail(index)
                        }}
                      >
                        {textList[index]}
                      </button>
                    </div>
                  </div>
                )
              })}

              {/* 참여 선언 */}
              <div className="relative flex flex-col">
                <span className="mb-1 text-left font-bold">
                  챌린지 참여 선언
                </span>
                <Controller
                  render={({ field: { onBlur, value, ...field } }) => (
                    <>
                      <TextAreaMyVideo
                        value={value}
                        {...field}
                        placeholder="참여선언 한 블로그나 유튜브 링크 입력"
                        className={classNames('bg-[#F6F8FB]', {
                          'text-[#8F929B]': text === '저장됨',
                        })}
                        disabled={createPending || text === '저장됨'}
                      />
                    </>
                  )}
                  name={'link'}
                  rules={{
                    required: {
                      value: true,
                      message: 'Link 입력은 필수입니다!',
                    },
                  }}
                  control={control}
                />
                <div className="absolute -bottom-14 right-2 top-0 flex items-center gap-[16px]">
                  <button
                    type="button"
                    onClick={() => {
                      setValue('link', '')
                      setText('적용')
                    }}
                    disabled={createPending}
                  >
                    <img
                      className="h-[32px] w-[32x]"
                      src="assets/img/icon_circle_x.png"
                      alt="x"
                    />
                  </button>
                  <button
                    className={classNames(
                      'flex h-[43px] w-[76px] items-center justify-center rounded-[10px] bg-[#6B8ACB] font-bold text-white hover:bg-[#8FABE5] disabled:opacity-[0.3]',
                      {
                        'active:scale-95': text === '적용',
                      },
                    )}
                    disabled={createPending || text === '저장됨'}
                    onClick={handleCreateChallenge}
                  >
                    {text}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="flex h-[60px] w-[330px] items-center justify-center text-[14px] font-bold">
            <button
              className="h-full w-[50%] rounded-bl-[20px] border-b border-[#EEF1F7] bg-[#EEF1F7] text-black"
              onClick={() => {
                setShowRevenueModal(false)
              }}
              disabled={isPending}
              type="button"
            >
              취소
            </button>
            <button
              className="h-full w-[50%] rounded-br-[20px] border-b border-main bg-main font-bold text-white"
              onClick={() => {
                setShowRevenueModal(false)
              }}
              disabled={isPending}
              type="button"
            >
              확인
            </button>
          </div>
        </Modal>
      )}
      <Modal isModal={isOpenDay}>
        <div className="flex max-h-[600px] w-[335px] flex-col gap-4 overflow-y-scroll rounded-t-[40px] border-t bg-white px-5 pt-8 md:max-h-[600px]">
          <div className="flex flex-col gap-4">
            <p className="text-[18px] font-bold">
              🧑‍💻 오늘은 수익 인증일이 아니에요!
            </p>
            <p className="pb-8 text-[14px]">
              수익 인증은{' '}
              <span className="font-bold text-error">
                매 월 1일에 한 번, 15일에 한 번<br />
              </span>{' '}
              총 2회 해주세요
            </p>
          </div>
        </div>
        <div className="flex h-[60px] w-[335px] items-center justify-center text-[14px] font-bold">
          <button
            className="h-full w-[100%] rounded-b-[40px] border-b border-main bg-main font-bold text-white"
            onClick={() => {
              setOpenDay(false)
            }}
            disabled={isPending}
            type="button"
          >
            확인
          </button>
        </div>
      </Modal>
    </>
  )
}
